
























































// This component is typically used as a dynamic component inside ModalWrapperComponent
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { TokenUser } from '@/TokenUser';
import { Alert, alertChannel, alertStatus } from '@/Alert';
import * as utils from '../utils';
import * as utils_auth from '../utils_auth';
import * as utils_tracker from '../utils_tracker';
import * as utils_topshot from '../utils_topshot';
import { globalUC } from '../UserCache';
import ModalWrapperComponent from '@/components/ModalWrapperComponent.vue';             // @ is an alias to /src
import MomentSelectorAndSorterComponent from '@/components/MomentSelectorAndSorterComponent.vue';                       // @ is an alias to /src

@Component({
  name: 'AlertForm',
  components: { ModalWrapperComponent, MomentSelectorAndSorterComponent }
})
export default class AlertFormComponent extends Vue {
  // prop reactive member variables publically available to the html template

  // public reactive member variables available to the html template
  public alertId: string = null     // if editing
  public alertName: string = null
  public minPrice: string = null
  public maxPrice: string = null
  public minSerial: string = null
  public maxSerial: string = null
  public playerID: number = null
  public setID: number = null
  public playID: number = null
  public team: string = 'All Teams'

  public jersey: boolean = false
  public lastMint: boolean = false
  public neverSold: boolean = false
  public lowAsk: boolean = false
  public tsdebut: boolean = false
  public rookieYear: boolean = false
  public rookieMint: boolean = false
  public rookiePremiere: boolean = false
  public champYear: boolean = false
  public challengeReward: boolean = false
  public craftingChallengeReward: boolean = false

  public channels: alertChannel[] = null

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }
  public get user(): TokenUser { return this.$store.getters.userObject }
  public get userId(): string { return this.$store.getters.userId }

  // events from MomentSelectorAndSorterComponent
  public async onChangedPSD(player: { label: string, playerID: number }, set: { label: string, setID: number }, duo: { label: string, setID: number, playID: number }) {
    this.playerID = player.playerID
    this.setID = duo.setID || set.setID
    this.playID = duo.playID
  }  

  public minDealRatings: Array<{ label: string, minRating: number }> = [
    { label: 'Ignore flames', minRating: 0 },
    { label: 'Anything below FMV', minRating: 0.5 },
    { label: 'At least 🔥', minRating: 1 },
    { label: 'At least 🔥🔥', minRating: 2 },
    { label: 'At least 🔥🔥🔥', minRating: 3 },
    { label: 'At least 🔥🔥🔥🔥', minRating: 4 },
    { label: 'At least 🔥🔥🔥🔥🔥', minRating: 5 },
  ]
  public minDealRating: { label: string, minRating: number } = this.minDealRatings[0]

  public teams: string[] = [
    'All Teams',
    'Atlanta Hawks', 'Boston Celtics', 'Brooklyn Nets', 'Charlotte Hornets',
    'Chicago Bulls', 'Cleveland Cavaliers', 'Dallas Mavericks', 'Denver Nuggets',
    'Detroit Pistons', 'Golden State Warriors', 'Houston Rockets', 'Indiana Pacers',
    'LA Clippers', 'Los Angeles Lakers', 'Memphis Grizzlies', 'Miami Heat',
    'Milwaukee Bucks', 'Minnesota Timberwolves', 'New Orleans Pelicans', 'New York Knicks',
    'Oklahoma City Thunder', 'Orlando Magic', 'Philadelphia 76ers', 'Phoenix Suns',
    'Portland Trail Blazers', 'Sacramento Kings', 'San Antonio Spurs', 'Toronto Raptors',
    'Utah Jazz', 'Washington Wizards',
    'Team Durant', 'Team LeBron',
    'Atlanta Dream', 'Chicago Sky', 'Connecticut Sun', 'Dallas Wings', /* 'Detroit Shock', */ 'Houston Comets', 'Indiana Fever', 'Las Vegas Aces',
    'Los Angeles Sparks', 'Minnesota Lynx', 'New York Liberty', 'Phoenix Mercury', 'Sacramento Monarchs', /* 'San Antonio Silver Stars', */ 'Seattle Storm', 'Washington Mystics'
  ]

  public get alertChannelOptions(): Array<{ text: string, value: number, disabled: boolean }> {
    const options: Array<{ text: string, value: number, disabled: boolean }> = []
    options.push({ text: 'Email', value: alertChannel.Email, disabled: !this.user.emailVerified })
    options.push({ text: 'Telegram', value: alertChannel.Telegram, disabled: !this.user.telegramConfirmed })
    return options
  }

  public onCancel() {
    this.$emit('close', false)
    this.clearFields()
  }
  public clearFields() {
    this.alertName = null
    this.minPrice = null
    this.maxPrice = null
    this.minDealRating = this.minDealRatings[0]
    this.minSerial = null
    this.maxSerial = null

    this.jersey = false
    this.lastMint = false
    this.neverSold = false
    this.lowAsk = false
    this.tsdebut = false
    this.rookieYear = false
    this.rookieMint = false
    this.rookiePremiere = false
    this.champYear = false
    this.challengeReward = false
    this.craftingChallengeReward = false
    this.team = 'All Teams'

    // smart defaults that favor Telegram
    this.channels = []
    if (this.user.emailVerified && this.user.telegramConfirmed) this.channels = [ alertChannel.Telegram ]
    if (this.user.emailVerified && !this.user.telegramConfirmed) this.channels = [ alertChannel.Email ]
    if (!this.user.emailVerified && this.user.telegramConfirmed) this.channels = [ alertChannel.Telegram ]
    
    // TODO momentSelector
  }
  public async onShow(dynamicProps: any) {
    this.clearFields()

    if (dynamicProps) {
      const alert: Alert = dynamicProps
      this.alertId = alert.getIdAsString()
      this.alertName = alert.alertName
      if (alert.minPrice) this.minPrice = alert.minPrice.toString()
      if (alert.maxPrice) this.maxPrice = alert.maxPrice.toString()
      if (alert.minSerial) this.minSerial = alert.minSerial.toString()
      if (alert.maxSerial) this.maxSerial = alert.maxSerial.toString()
      this.jersey = alert.jersey
      this.lastMint = alert.lastMint
      this.neverSold = alert.neverSold
      this.lowAsk = alert.lowAsk
      this.tsdebut = alert.tsdebut
      this.rookieYear = alert.rookieYear
      this.rookieMint = alert.rookieMint
      this.rookiePremiere = alert.rookiePremiere
      this.champYear = alert.champYear
      this.challengeReward = alert.challengeReward
      this.craftingChallengeReward = alert.craftingChallengeReward
      this.team = utils_topshot.longTeamName(alert.team)

      // for channels
      this.channels = alert.channels || []

      // for dealRating v-select
      if (alert.dealRating) for (const minDealRating of this.minDealRatings) if (minDealRating.minRating === alert.dealRating) this.minDealRating = minDealRating

      // for momentSelector prefills
      if (alert.playerID) this.playerID = alert.playerID
      if (alert.setID) this.setID = alert.setID
      if (alert.playID) this.playID = alert.playID
      
      const promises: Array<Promise<any>> = []

      if (this.playerID) promises.push((this.$refs.MomentSelectorAndSorterComponent as MomentSelectorAndSorterComponent).notifyChangedPlayerIDFromParent(this.playerID))
      if (this.setID && !this.playID) promises.push((this.$refs.MomentSelectorAndSorterComponent as MomentSelectorAndSorterComponent).notifyChangedSetIDFromParent(this.setID))
      if (this.playerID && this.setID && this.playID) promises.push((this.$refs.MomentSelectorAndSorterComponent as MomentSelectorAndSorterComponent).notifyChangedPlayerIDAndSetIDAndPlayIDFromParent(this.playerID, this.setID, this.playID))
      await Promise.all(promises)
    }
  }

  public async onOK() {
    // do hidden fields
    const status: alertStatus = alertStatus.Enabled

    // tidy up form fields
    if (this.alertName) this.alertName = this.alertName.trim()
    if (this.minPrice) this.minPrice = this.minPrice.replace(/\D/g, "");
    if (this.maxPrice) this.maxPrice = this.maxPrice.replace(/\D/g, "");
    if (this.minSerial) this.minSerial = this.minSerial.replace(/\D/g, "");
    if (this.maxSerial) this.maxSerial = this.maxSerial.replace(/\D/g, "");

    // convert number fields
    const minPrice: number = this.minPrice ? Number(this.minPrice) : null
    const maxPrice: number = this.maxPrice ? Number(this.maxPrice) : null
    const minSerial: number = this.minSerial ? Number(this.minSerial) : null
    const maxSerial: number = this.maxSerial ? Number(this.maxSerial) : null

    // for channels
    const channels: alertChannel[] = this.channels

    // from dealRating v-select
    const dealRating: number = this.minDealRating.minRating

    // from momentSelector
    const playerID: number = this.playerID ? this.playerID : null
    const setID: number = this.setID ? this.setID : null
    const playID: number = this.playID ? this.playID : null

    // advanced stuff
    const jersey: boolean = this.jersey
    const lastMint: boolean = this.lastMint
    const neverSold: boolean = this.neverSold
    const lowAsk: boolean = this.lowAsk
    const tsdebut: boolean = this.tsdebut
    const rookieYear: boolean = this.rookieYear
    const rookieMint: boolean = this.rookieMint
    const rookiePremiere: boolean = this.rookiePremiere
    const champYear: boolean = this.champYear
    const challengeReward: boolean = this.challengeReward
    const craftingChallengeReward: boolean = this.craftingChallengeReward

    const team: string = this.team === 'All Teams' ? null : this.team

    // validate form fields
    let abort: boolean = false
    // if (!this.alertName || this.alertName.length === 0) { abort = true; utils.toast(this, 'Missing field', 'Please give your alert a name') }
    if (isNaN(minPrice)) { abort = true; utils.toast(this, 'Invalid field', 'Minimum price') }
    if (isNaN(maxPrice)) { abort = true; utils.toast(this, 'Invalid field', 'Maximum price') }
    if (isNaN(minSerial)) { abort = true; utils.toast(this, 'Invalid field', 'Minimum serial #') }
    if (isNaN(maxSerial)) { abort = true; utils.toast(this, 'Invalid field', 'Maximum serial #') }

    if (abort) return

    // make POST or PUT call to server
    try {
      this.$store.commit('setLoading', { loading: true });
      let url: string = utils.getURLprefix() + '/api/topshot/alert';
      if (this.alertId) url += `/${this.alertId}`
      const postData: any = { status, channels, alertName: this.alertName, minPrice, maxPrice, dealRating, minSerial, maxSerial, playerID, setID, playID, jersey, lastMint, neverSold, lowAsk, tsdebut, rookieYear, rookieMint, rookiePremiere, champYear, challengeReward, craftingChallengeReward, team } 
      const response: any = this.alertId ? await utils.makePutCall(url, postData) : await utils.makePostCall(url, postData)
      if (!response || !response.data) throw(new Error('AlertFormComponent.onOK() got null response or null response.data'))

      // something is wrong with the alert
      if (response.data.error) {
        utils.toast(this, 'Error', response.data.error)
      }
      
      // might as well update the user
      if (response.data.user) {
        const user: TokenUser = new TokenUser(response.data.user)
        user.email = response.data.email     // this got stripped away to make safe for client
        utils_auth.saveAuthStuffToStoreAndLocalStorage(user, response.data.sessionId)
        globalUC.add(user)      // might as well give cache the very latest one
      }

      // success
      if (response.data.alert) {
        const alert: Alert = new Alert(response.data.alert)
        utils.toast(this, 'Success', `Alert ${ this.alertId ? 'Updated' : 'Created' }.`)
        this.$emit('close', alert)
        this.clearFields()

        // utils_tracker.track(`Alert ${ this.alertId ? 'Updated' : 'Created' }`, { alertDescription: alert.description, user: this.user.getIdAsString() })
      }

    } catch (error) {
      utils.toast(this, 'System Error', 'Could not save alert')
      if (this.$store.state.devmode) console.error(error);
    } finally {
      this.$store.commit('setLoading', { loading: false });
    }

  }

  // private, non-reactive member variables

  // private functions not available directly to HTML template
  private async mounted() { 
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)

    utils_tracker.page(this.$options.name)

    // utils_tracker.track(`Alert Form Shown`, {  user: this.user.getIdAsString() })

  }
  private async beforeDestroy() { if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`) }

}
